import React, { useState } from "react";
import Modal from "../common/Modal/Modal";
import MHeader from "./common/MHeader";
import MFooter from "./common/MFooter";
import { ReactComponent as CloseIcon } from "./../../resources/images/icons/modalCloseIcon.svg";
import { useDiscardDraftMutation } from "../../redux/apis/manageJobPostingHooks";
// import CustomSnackbar from "../common/Snackbar/CustomSnackbar";
import { toast } from "react-toastify";

interface Props {
  isOpen: boolean;
  setIsOpen: Function;
  draftName?: string;
  id?: number;
}

const DiscardDraftModal = ({ isOpen, setIsOpen, draftName, id }: Props) => {
  // const [snackbarOpen, setSnackbarOpen] = useState(false);
  // const [isError, setIsError] = useState(false);
  const [discardDraft, { isLoading }] = useDiscardDraftMutation();

  const handleClose = () => {
    setIsOpen(false);
  };

  // const handleSnackbarOpen = () => {
  //   setSnackbarOpen(true);
  // };

  // const handleSnackbarClose = () => {
  //   setSnackbarOpen(false);
  // };

  const handleDiscardDraft = async () => {
    if (id !== undefined) {
      const response: any = await discardDraft(id);
      if (response?.data) {
        // setIsError(false);
        toast.success("Job Discarded Successfully", {
          autoClose: 5000,
          position: "bottom-left",
          toastId: "success-toast-custom",
        });
        handleClose();
      } else {
        // setIsError(true);
        toast.error("Error discarding job!", {
          autoClose: 5000,
          position: "bottom-left",
          toastId: 'error-toast-custom',
        });
      }
      // handleSnackbarOpen();
    }
  };

  const Header = (
    <MHeader>
      <span className="mjp-modal-text-header">Discard draft</span>
    </MHeader>
  );

  const Footer = (
    <MFooter>
      <div className="discard-draft-footer">
        <div style={{ width: "48%" }}>
          <button
            className="foundit-button medium full-width discard-cancel-button"
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </button>
        </div>
        <div style={{ width: "48%" }}>
          <button
            className="foundit-button primaryButton medium full-width"
            onClick={handleDiscardDraft}
            disabled={isLoading}
          >
            {!isLoading ? "Discard Now" : "Discarding..."}
          </button>
        </div>
      </div>
    </MFooter>
  );

  return (
    <React.Fragment>
      <Modal
        modalId="mjp-modal-discard-draft"
        isOpen={isOpen}
        onClose={() => {
          if (!isLoading) {
            setIsOpen(false);
          }
        }}
        header={Header}
        footer={Footer}
        closeIcon={<CloseIcon />}
        width="360px"
      >
        <div className="mjp-modal-body discard-draft-body">
          Are you sure, you want to discard <b>{draftName}</b>
        </div>
      </Modal>

      {/* <CustomSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={
          isError ? "Error discarding job!" : "Job Discarded Successfully"
        }
        variant={isError ? "error" : "success"}
      /> */}
    </React.Fragment>
  );
};

export default DiscardDraftModal;
